import cx from "clsx";
import type React from "react";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionList.module.scss";

type Props = {
	constructionContext: DealConstructionContext;
	docType: "billing" | "estimation";
	showButtons?: boolean;
	showSwitchEnable?: boolean;
};

export const ConstructionAmountRow: React.FC<Props> = ({
	constructionContext,
	docType,
	showButtons = false,
	showSwitchEnable = false
}: Props) => {
	const { constructionTotalAmount, constructionTotalAmountWithTax } =
		constructionContext;
	return (
		<tr className={cx(Styles.ListRow, Styles.Footer)}>
			<td className={Styles.OrderHandle} />
			{showSwitchEnable ? <td className={Styles.SwitchEnable} /> : null}
			{docType === "estimation" ? (
				<td className={Styles.EstimationType} />
			) : null}
			<td className={Styles.Estimation}>
				<div className={Styles.Point}>工事代金（管理会社請求額）</div>
			</td>
			<td className={Styles.UnitAmount} />
			<td className={Styles.ChargePer} />
			<td className={Styles.Amount}>
				¥{toThousandSeparator(constructionTotalAmount)}
				<div>
					(税込：¥{toThousandSeparator(constructionTotalAmountWithTax)})
				</div>
			</td>
			{showButtons ? <td className={Styles.Buttons} /> : null}
		</tr>
	);
};
